export interface ClientEnv {
  relayBaseUrl: string;
}

export function readEnv(): ClientEnv {
  const raw = (import.meta.env.VITE_RELAY_BASE_URL ?? '').trim();

  // Empty (or unset) = same-origin: derive from the page's URL. This is what
  // production deploys want when the SPA and the API are served from the
  // same domain via a reverse proxy.
  if (raw === '') {
    if (typeof window === 'undefined') {
      // Pre-render / test context — fall back to a local default.
      return { relayBaseUrl: 'http://localhost:8080' };
    }
    return { relayBaseUrl: window.location.origin };
  }

  if (!/^https?:\/\//.test(raw)) {
    throw new Error(`VITE_RELAY_BASE_URL must be an http(s) URL or empty: ${raw}`);
  }
  return { relayBaseUrl: raw.replace(/\/+$/, '') };
}
